import { render } from "./PaymentProviderContent.vue?vue&type=template&id=25dd41df&scoped=true"
import script from "./PaymentProviderContent.vue?vue&type=script&lang=js"
export * from "./PaymentProviderContent.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25dd41df"]])

export default __exports__